import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import Modal from "react-bootstrap/Modal";

interface Props {
    closeModal: () => void;
    manualActionDeviceMenuX: number;
    manualActionDeviceMenuY: number;
    deleteManualAction: () => void;
}

const ManualActionDeviceMenuItems = (props: Props) => {


    const handleDelete = () => {
        props.deleteManualAction();
        props.closeModal()
    }

    return (
        <Modal
            show={true}
            size="sm"
            animation={false}
            onEscapeKeyDown={() => props.closeModal()}
            onHide={() => props.closeModal()}
        >
            <div className="device_menuItems" style={{ position: "fixed", display: 'block', top: `${props.manualActionDeviceMenuY}px`, left: `${props.manualActionDeviceMenuX}px` }}>
                <span id="device_delete" onClick={handleDelete}>Delete</span>
            </div>
        </Modal>
    );
}

export default ManualActionDeviceMenuItems;